import { gql } from '@apollo/client';

export const GENERATE_PICKUP_SITE_DETAIL_DOWNLOAD = gql`
    mutation GeneratePickupSiteDetailDownloadReport($input: PickupDashboardSiteDetailQueryInput!, $timezone: String) {
        generatePickupSiteDetailDownloadReport(input: $input, timezone: $timezone)
    }
`;
